import { gql } from '@apollo/client';
import NotificationMessageDTO from '../fragments/notificationMessageDTO.fragment.notification';

export default gql`
  subscription putNotificationSubscription($userId: String!) {
    putNotificationSubscription(userId: $userId) {
      ...NotificationMessageDTO
    }
  }
  ${NotificationMessageDTO}
`;
